import { Box, BoxProps } from '@mui/material';

export const BottomActionBar = ({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: BoxProps['sx'];
}) => {
  return (
    <Box
      py={1}
      px={3}
      sx={{
        ...sx,
        display: 'flex',
        background: 'rgba(247, 247, 248, 0.8)',
        backdropFilter: 'blur(2px)',
        border: '1px solid #EDEDED',
        position: 'fixed',
        bottom: 0,
        right: 0,
        left: 0,
      }}
    >
      {children}
    </Box>
  );
};
